import React, {useEffect, useState} from 'react';
import Header from '../components/header/header';
import Footer from '../components/statics/footer';
import {Row, Input} from 'reactstrap';

const ContactScreen = ({}) => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    return (
        <div>
            {/* <Header /> */}
            <div className='container-form'>
                <h4 style={{textAlign: 'center'}}>Tem alguma sugestão ou reclamação?</h4>
                <h5 style={{textAlign: 'center'}}>Mande para nossa equipe através do formulário abaixo</h5>
                <form className="generic-form">
                    <div className="form-group">
                        <label>Nome</label>
                        <input type="text" className="form-control input-container" id="name" placeholder="Digite seu nome" onChange={setName} required></input>
                    </div>
                    <div className="form-group">
                        <label>E-mail</label>
                        <input type="email" className="form-control input-container" id="email" aria-describedby="emailHelp" placeholder="Digite seu e-mail" onChange={setEmail} required></input>
                    </div>
                    <div className="form-group">
                        <label>Assunto</label>
                        <input type="text" className="form-control input-container" id="subject" placeholder="Digite o assunto da mensagem" onChange={setSubject} required></input>
                    </div>
                    <div className="form-group">
                        <label>Mensagem</label>
                        <Input type="textarea" name="message" className="form-control input-container" onChange={setMessage} required/>
                    </div>
                    <div className="mt-3 mb-0">
                        <Row className='justify-content-center'>
                            <button className="btn-form mb-1" type="submit" value="Login">Enviar</button>
                        </Row>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
}

export default ContactScreen;